import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";
import { Dropzone } from "dropzone";

export default class extends Controller {
  static targets = ["fileInput", "fileList", "dropZone", "submit"];

  connect() {
    Dropzone.autoDiscover = false;

    this.dropzone = new Dropzone(this.dropZoneTarget, {
      url: this.fileInputTarget.dataset.directUploadUrl,
      autoProcessQueue: false,
      autoQueue: false,
      disablePreviews: true,
      acceptedFiles:
        "image/*,application/pdf,text/csv,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation",
      maxFiles: this.fileInputTarget.multiple ? null : 1,
    });
    this.dropzone.on("addedfile", (file) => {
      this.uploadFile(file);
    });

    this.formTarget = this.element.closest("form");
  }

  disconnect() {
    if (this.dropzone) {
      this.dropzone.destroy();
    }
  }

  uploadFile(file) {
    const fileInput = this.fileInputTarget;
    const url = fileInput.dataset.directUploadUrl;
    const upload = new DirectUpload(file, url);

    const listItem = document.createElement("div");
    listItem.classList.add(
      "flex",
      "justify-between",
      "px-3",
      "py-2",
      "bg-yellow-100",
      "text-sm",
      "rounded-md",
      "animate-pulse"
    );
    const label = document.createElement("div");
    const status = document.createElement("strong");
    status.textContent = "Uploading";
    label.append(status, ` ${file.name}`);
    listItem.append(label);

    if (!fileInput.multiple) {
      this.fileListTarget.innerHTML = "";
      this.dropZoneTarget.classList.add("hidden");
    }

    this.fileListTarget.appendChild(listItem);

    upload.create((error, blob) => {
      if (error) {
        this.dropZoneTarget.classList.remove("hidden");
        // TODO: handle error
      } else {
        listItem.textContent = file.name;

        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("value", blob.signed_id);
        hiddenField.name = this.fileInputTarget.name;
        listItem.appendChild(hiddenField);

        const deleteButton = document.createElement("button");
        deleteButton.classList.add("font-bold");
        deleteButton.textContent = "\u2715";
        deleteButton.addEventListener("click", () => {
          listItem.remove();

          if (!fileInput.multiple) {
            fileInput.setAttribute("value", "");
            this.dropZoneTarget.classList.remove("hidden");
          }

          const fileCount = this.fileListTarget.querySelectorAll("input").length;
          if (fileCount === 0 && this.hasSubmitTarget) {
            this.submitTarget.disabled = true;
          }

          this.dispatchFormChange();
        });
        listItem.appendChild(deleteButton);

        listItem.classList.remove("bg-yellow-100");
        listItem.classList.remove("animate-pulse");
        listItem.classList.add("bg-green-100");

        if (this.hasSubmitTarget) {
          this.submitTarget.disabled = false;
        }

        this.dispatchFormChange();
      }
    });
  }

  removeFile(event) {
    event.target.parentElement.remove();
    this.dispatchFormChange();
  }

  dispatchFormChange() {
    this.formTarget.dispatchEvent(new Event("change", { bubbles: false, cancelable: true }));
    this.element.dispatchEvent(new Event("form:files:change", { bubbles: true, cancelable: true }));
  }
}
